// extracted by mini-css-extract-plugin
module.exports = {"connectBtn":"Account_connectBtn__8Bnsc"};